import React from 'react';
import { Button } from 'reactstrap';

class Timer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            timeDiff: this.props.timeTracking != null ? this.props.timeTracking.timeDiff : 0
        };

        this.interval = setInterval(() => {
            if (this.props.timeTracking != null && this.props.timeTracking.endTimestamp == null) {
                const timeOffset = this.props.loadedServerTimestamp - this.props.loadedPageTimestamp;
                const beginTimestamp = new Date(this.props.timeTracking.beginTimestamp);
                const timeDiff = new Date().getTime() - beginTimestamp.getTime() + timeOffset;
                this.setState({
                    timeDiff: timeDiff
                });
            }
        }, 1000);

    };

    componentWillUnmount = () => {
        this.props.log('Timer.js/componentWillUnmount');
        clearInterval(this.interval);
    }

    msToTime = (s) => {
        this.props.info('Timer.js/msToTime');
        var ms = s % 1000;
        s = (s - ms) / 1000;
        var secs = s % 60;
        s = (s - secs) / 60;
        var mins = s % 60;
        var hrs = (s - mins) / 60;
        mins = mins < 10 ? '0' + mins : mins;
        secs = secs < 10 ? '0' + secs : secs;
        return hrs + ':' + mins + ':' + secs;// + '.' + ms;
    }

    showTimer = () => {
        this.props.info('Timer.js/showTimer');
        if (this.props.timeTracking != null && this.props.timeTracking.endTimestamp == null) {
            // in process
            const beginTimestamp = new Date(this.props.timeTracking.beginTimestamp);
            return (<>
                {this.props.active ? <div className="timerLine"><span className="timerTitle">Start: </span> {this.props.formatAMPM(beginTimestamp)}</div> : <></>}
                <div className="timerLine"><span className="timerTitle">Elapsed: </span>{this.msToTime(this.state.timeDiff)}</div>
                {this.props.active ? <Button onClick={() => this.props.handleTimeTracking('end', { id: this.props.reportId, timestamp: this.props.timestamp, timeTracking: this.props.timeTracking })} color="danger">End</Button> : <></>}
            </>);
        } else if (this.props.timeTracking != null && this.props.timeTracking.endTimestamp != null) {
            // complete
            const beginTimestamp = new Date(this.props.timeTracking.beginTimestamp);
            const endTimestamp = new Date(this.props.timeTracking.endTimestamp);
            const timeDiffFinal = endTimestamp.getTime() - beginTimestamp.getTime();
            return (<>
                {this.props.active ? <div className="timerLine"><span className="timerTitle">Start: </span> {this.props.formatAMPM(beginTimestamp)}</div> : <></>}
                {this.props.active ? <div className="timerLine"><span className="timerTitle">End: </span> {this.props.formatAMPM(endTimestamp)}</div> : <></>}
                <div className="timerLine"><span className="timerTitle">Elapsed: </span> {this.msToTime(timeDiffFinal)}</div></>)
        } else {
            // has not started
            return (<>
                <div className="timerLine"><span className="timerTitle">Elapsed: </span> 0:00:00</div>
                {this.props.active ? <Button onClick={() => this.props.handleTimeTracking('begin', { id: this.props.reportId, timestamp: this.props.timestamp, timeTracking: this.props.timeTracking })} color="success">Start</Button> : <></>}
            </>);
        }
    }


    render() {
        this.props.info('TImer.js/render');
        return (
            <div className={this.props.active ? "timer" : ""}>{this.showTimer()}</div>
        );
    }
}

export default Timer;

